import ApiService from './ApiService'

export const getApiData = data => {
    var datas
    if (data) {
        datas = {
            page: data.pageIndex,
            page_size: data.pageSize,
        }
        data.sort?.map(sort => {
            if (!sort.dir) return sort
            datas.ordering = sort.dir === 'desc' ? `-${sort.column}` : `${sort.column}`
            return sort
        })
        if (data.query) {
            datas.search = data.query
        }
        if (data?.company) {
            datas.company_id = data?.company
        }
        if (data?.customer) {
            datas.customer_id = data?.customer
        }
        if (data.selectedTab) {
            datas.is_active = data.selectedTab === 'active'
        }
        if (data.id) {
            datas.id = data.id
        }
    }
    return ApiService.get('/api/v1/ensemble/warehouses/', datas)
}
export const createApiRecord = data => ApiService.post('/api/v1/ensemble/warehouses/', data)
export const getApiRecord = id => ApiService.get(`/api/v1/ensemble/warehouses/${id}/`)
export const updateApiRecord = (id, data) => ApiService.put(`/api/v1/ensemble/warehouses/${id}/`, data)
export const deleteApiRecord = id => ApiService.delete(`/api/v1/ensemble/warehouses/${id}/`)
